export default "__VITE_ASSET__CcWSWsSc__"